// extracted by mini-css-extract-plugin
export default {"container":"shortlist_header-module___container___ccc90fdd","sortByBlock":"shortlist_header-module___sortByBlock___c8c6a3af"};